export default __webpack_public_path__ + "static/media/logolimet_notext.742ac5ad.png";